import { gql, useMutation } from '@apollo/client';

import type { DeleteAccountMutation, DeleteAccountMutationVariables } from './__generated__/useDeleteAccount.gql';

const DELETE_ACCOUNT = gql`
  mutation DeleteAccount {
    deleteAccount {
      success
    }
  }
`;

/**
 * Self-serve account deletion. The server tombstones the user, revokes every
 * session, and dispatches an async purge that cascade-deletes the family, so the
 * caller only needs to redirect afterward — no Apollo cache invalidation, since
 * the ended session forces a fresh login.
 */
export const useDeleteAccount = () => {
  return useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DELETE_ACCOUNT);
};
